<details-card [title]="title | transloco" [description]="description | transloco">
  <div actions>
    <button
      *ngIf="hasProductScopedWords && !hasNoWords && !allWordsHaveProductScope"
      qai-link
      class="header-action"
      [disabled]="hasErrors || isApiRequestInProgress()"
      (click)="onResetToProductDefault()"
    >
      {{ 'simulationBuilder.KEYWORDS_RESET_TO_PRODUCT_DEFAULT' | transloco }}
    </button>
    <button
      *ngIf="!hasNoWords && allWordsHaveProductScope"
      qai-link
      class="header-action"
      [disabled]="isApiRequestInProgress()"
      (click)="onDetachFromProductDefault()"
    >
      {{ 'simulationBuilder.KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT' | transloco }}
    </button>
    <button
      *ngIf="!allWordsHaveProductScope"
      qai-link
      [disabled]="hasErrors || hasNoWords || isApiRequestInProgress()"
      class="header-action"
      (click)="saveAsProductDefault()"
    >
      {{ 'simulationBuilder.KEYWORDS_SAVE_AS_PRODUCT_DEFAULT' | transloco }}
    </button>
  </div>
  <div content class="content-container" *ngIf="sttWordsListControl">
    <qai-word-list
      [buttonText]="buttonText | transloco"
      [formControl]="sttWordsListControl"
      [getError]="getFieldError"
      [actionsDisabled]="hasErrors || isDeleteInProgress()"
      [deleteActionsDisabled]="isCreateUpdateInProgress()"
      (wordRemoved)="onWordRemoved($event)"
    >
      <button
        *ngIf="hasNoWords || !allWordsHaveProductScope"
        qai-link
        positionEnd
        class="header-action"
        [disabled]="hasNoWords || isGeneratingPrompt || isApiRequestInProgress()"
        (click)="onGenerateSttPrompt()"
      >
        <span *ngIf="isGeneratingPrompt">{{ 'simulationBuilder.KEYWORDS_GENERATING' | transloco }}</span>
        <span *ngIf="!isGeneratingPrompt">{{ 'simulationBuilder.KEYWORDS_GENERATE_STT_PROMPT' | transloco }}</span>
      </button>
    </qai-word-list>
  </div>
  <div *ngIf="showTextArea && sttPromptGroup && !hasNoWords" content class="textarea-container" [class.words-changed]="wordsListChanged">
    <qai-label [kind]="wordsListChanged ? 'warning' : 'secondary'" [size]="'medium'" [weight]="'bold'">
      stt_prompt
    </qai-label>
    <div [formGroup]="sttPromptGroup">
      <textarea
        qai-textarea
        autosize
        [maxLines]="30"
        formControlName="promptText"
      ></textarea>
    </div>
    <qai-label *ngIf="wordsListChanged" [kind]="'warning'" [size]="'small'" [weight]="'regular'" class="disclaimer-message">
      {{ 'simulationBuilder.KEYWORDS_STT_PROMPT_OUTDATED' | transloco }}
    </qai-label>
  </div>
</details-card>

<save-as-product-default-modal
  [open]="saveAsProductDefaultModalOpen"
  [moduleUuid]="moduleUuid"
  [keywordTitle]="keywordTitle | transloco"
  [networkRequestInProgress]="networkRequestInProgress"
  (confirm)="onSaveAsProductDefaultConfirm()"
  (closeModal)="onSaveAsProductDefaultModalClose()"
  (openChange)="saveAsProductDefaultModalOpen = $event"
></save-as-product-default-modal>

<dialog
  #errorDialog
  qai-dialog
  [description]="''"
  [heading]="'simulationBuilder.KEYWORDS_STT_CANNOT_SAVE_HEADING' | transloco"
  (afterClose)="onErrorModalAfterClose()"
  (closeButtonClicked)="onErrorModalClose()"
>
  <div class="content">
    <span>{{ 'simulationBuilder.KEYWORDS_STT_CANNOT_SAVE_BODY' | transloco }}</span>
  </div>

  <div class="modal-actions">
    <button
      qai-button
      kind="primary"
      size="medium"
      (click)="onErrorModalClose()"
    >
      {{ 'simulationBuilder.BUTTON_OK' | transloco }}
    </button>
  </div>
</dialog>
